import { render } from "./Nombre_page_courante.vue?vue&type=template&id=1a01b914"
import script from "./Nombre_page_courante.vue?vue&type=script&lang=js"
export * from "./Nombre_page_courante.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__